import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UtmParametersService } from '@core/services/utm-parameters.service';
import { hero, heroTitlesData } from '@pages/main/db/main.db';
import { MainHeroImports } from '@pages/main/hero-v2/main-hero.imports';
import { EnMinWidthScreen } from '@shared/constants/screen-breakpoints';
import { IHeroInfo } from '@shared/hero-info/hero-info.interfaces';

@Component({
  selector: 'noda-main-hero-v2',
  standalone: true,
  templateUrl: './main-hero.component.html',
  styleUrls: ['./main-hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: MainHeroImports,
})
export class MainHeroComponent {
  public readonly data: IHeroInfo = hero;
  public readonly titlesData: string[] = heroTitlesData;
  public readonly enMinWidthScreen: typeof EnMinWidthScreen = EnMinWidthScreen;

  constructor(public utmService: UtmParametersService) {}
}
